import moment from 'moment';

export const MIN_REPORTING_INTERVAL = moment.duration(3, 'minutes').asMilliseconds();
export const MAX_LAST_TIME_LOCATION = moment.duration(2, 'hours').asMilliseconds();
